import React from 'react';
import { EBookDownload } from './view/ebookDownload';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'EbookDownload',
  itemElt: (item, cmsOption) => <EBookDownload item={item} cmsOption={cmsOption} />,
};
